module.exports = __webpack_public_path__ + "img/cosys.0662259b.png";